import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="post--insert-cta"
export default class extends Controller {
  static targets = ["content", "cta"]
  static values = {
    offsetHeight: {
      default: 720,
      type: Number
    }
  }
  connect() {
    const contentElements = this.contentTarget.children[0].children

    // Fetches the threshold element
    let cumulativeHeight = 0
    const thresholdElementIndex = [...contentElements].findIndex(element => {
      cumulativeHeight += element.offsetHeight
      return cumulativeHeight > this.offsetHeightValue
    })

    // Guarding smaller content
    if (thresholdElementIndex === -1) return

    this.insertTemplate(contentElements[thresholdElementIndex])
  }

  insertTemplate(thresholdElement) {
    if (!!document.getElementById("content-middle-cta")) return false

    const clone = this.ctaTarget.content.cloneNode(true)
    thresholdElement.after(clone)
  }
}
